import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import {IMAGE_URL} from "../path";


function TradeWithUs() {
    const img = IMAGE_URL + '/trade-1.jpg';
    const linkStyle: React.CSSProperties = {
        color: 'black',
        fontSize: '10px',
        textTransform: 'uppercase',
        fontFamily: "'Vinimark-Diatype', sans-serif",
        fontWeight: 600,
        marginBottom: 0,
    };

    document.title = "Vinimark | Trade With Us";

    return <div style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        width: '100%',
        // overflow: 'hidden'
    }}>

    <Header />
        <div>
            <div
                style={{
                    position: window.innerWidth > 768 ? 'relative' : 'static',
                    left: window.innerWidth > 768 ? '50%' : 'auto',
                    paddingLeft: window.innerWidth > 768 ? '0' : '20px',
                    marginTop: '140px',
                    width: window.innerWidth > 768 ? '40%' : '80%',
                    textAlign: 'left',
                    marginLeft: '26px'
                }}
            >
                <p style={{fontSize: '13px', lineHeight: '16.9px', fontWeight: 600}}>
                    TRADE WITH US
                </p>
                <p style={{fontSize: '13px', lineHeight: '16.9px' }}>
                    To register as a Vinimark customer, kindly select the correct application option below:
                </p>

                <p style={{fontSize: '13px', lineHeight: '16.9px', marginBottom: 0 }}>
                    <a style={linkStyle} href="https://app.fabricworkflows.com/external/redirects/subject-initiated-credit-application/c55244f7-f915-40fd-9cc0-018fc8d2fefd " target="_blank" rel="noreferrer">
                        Credit Application
                    </a>
                </p>
                <p style={{fontSize: '13px', lineHeight: '16.9px', marginTop: 0 }}>
                    30 Days from Statement Date or EFT – 48hrs after Delivery
                </p>
                <p style={{fontSize: '13px', lineHeight: '16.9px', marginBottom: 0 }}>
                    <a style={linkStyle} href="https://app.fabricworkflows.com/external/redirects/subject-initiated-credit-application/91c59037-4312-4039-b576-01916a2890bb" target="_blank" rel="noreferrer">
                        Prepaid Application
                    </a>
                </p>
                <p style={{fontSize: '13px', lineHeight: '16.9px', marginTop: 0 }}>
                    EFT Before Delivery
                </p>
                <p style={{fontSize: '13px', lineHeight: '16.9px' }}>
                    Please note that Vinimark is licensed to sell only to those entities or individuals residing in South Africa and who are in possession of a liquor licence. For our international trade partners, please contact our international team at the link below:
                </p>
                <a
                    style={linkStyle}
                    href="mailto:VeroniqueC@vinimark.co.za?subject=Vinimark%20International%20Sales%20Team%20Enquiry"
                >
                    Contact our international sales team
                </a>

            </div>
            <div
                style={{
                    marginTop: "125px",
                    marginBottom: "50px",
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <img
                    src={img}
                    alt="Trade with us"
                    style={{
                        width: window.innerWidth > 768 ? "25%" : "50%",
                    }}
                />
            </div>
        </div>
        <Footer />
    </div>
}

export default TradeWithUs;
